// crypto.randomUUID() is only defined in a "secure context" (HTTPS or
// localhost). The IP-mode demo is served over plain HTTP (http://<ip>:3000),
// where crypto.randomUUID is undefined — calling it (e.g. the Chatbot session
// id) throws "crypto.randomUUID is not a function" and crashes the app.
//
// crypto.getRandomValues IS available in non-secure contexts, so build a
// compliant RFC 4122 v4 UUID from it and install it as a fallback. No-op when
// the native (secure-context) implementation exists.
if (
  typeof crypto !== 'undefined' &&
  typeof crypto.randomUUID !== 'function' &&
  typeof crypto.getRandomValues === 'function'
) {
  const hex = []
  for (let i = 0; i < 256; i++) hex.push((i + 0x100).toString(16).slice(1))

  crypto.randomUUID = function randomUUID() {
    const b = crypto.getRandomValues(new Uint8Array(16))
    b[6] = (b[6] & 0x0f) | 0x40 // version 4
    b[8] = (b[8] & 0x3f) | 0x80 // variant 10xx
    return (
      hex[b[0]] + hex[b[1]] + hex[b[2]] + hex[b[3]] + '-' +
      hex[b[4]] + hex[b[5]] + '-' +
      hex[b[6]] + hex[b[7]] + '-' +
      hex[b[8]] + hex[b[9]] + '-' +
      hex[b[10]] + hex[b[11]] + hex[b[12]] + hex[b[13]] + hex[b[14]] + hex[b[15]]
    )
  }
}
